import React from 'react';
import { CardMediaImage } from '@udemy/react-product-card-components';
export const buildWideSrcSetAttributes = ({
  course: {
    image_240x135,
    image_304x171,
    image_480x270,
    image_750x422
  }
}) => {
  const widthsWithSources = [[image_240x135, '240w'], [image_304x171, '304w'], [image_480x270, '480w'], [image_750x422, '750w']];
  const srcSet = widthsWithSources.filter(([imgSrc]) => !!imgSrc).map(entry => entry.join(' ')).join(', ');
  return {
    srcSet: srcSet,
    sizes: 'auto'
  };
};

/**
 * Produces media props for the `CourseProductCard` from the course image properties
 * in a `Course` object
 */
export const courseCardMediaProps = ({
  course
}) => {
  const {
    image_50x50,
    image_100x100,
    image_240x135
  } = course;
  return {
    mediaSquare: /*#__PURE__*/React.createElement(CardMediaImage, {
      src: image_50x50,
      src2x: image_100x100,
      layout: 'square'
    }),
    mediaWide: /*#__PURE__*/React.createElement(CardMediaImage, Object.assign({
      src: image_240x135,
      layout: 'wide'
    }, buildWideSrcSetAttributes({
      course
    })))
  };
};
//# sourceMappingURL=course-card-media.js.map